import { render, staticRenderFns } from "./SystemScoreDescriptionRow.vue?vue&type=template&id=68d6c86e&scoped=true&"
import script from "./SystemScoreDescriptionRow.vue?vue&type=script&lang=js&"
export * from "./SystemScoreDescriptionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6c86e",
  null
  
)

export default component.exports